import Account from '@/api/accounts'

export default {
  namespaced: true,
  state: {
    firstName: '',
    lastName: '',
    email: '',
    captcha: '',
    profile: '',
    accountName: '',
    authority: '',
    publicKey: '',
    error: null,
    loading: false
  },
  getters: {
    formData: state => {
      return {
        firstName: state.firstName,
        lastName: state.lastName,
        email: state.email,
        captcha: state.captcha
      }
    }
  },
  mutations: {
    setFirstName (state, name) {
      state.firstName = name
    },
    setLastName (state, name) {
      state.lastName = name
    },
    setEmail (state, email) {
      state.email = email
    },
    setCaptcha (state, captcha) {
      state.captcha = captcha
    },
    setProfile (state, profile) {
      state.profile = profile
    },
    setAccountName (state, accountName) {
      state.accountName = accountName
    },
    setAuthority (state, authority) {
      state.authority = authority
    },
    setPublicKey (state, publicKey) {
      state.publicKey = publicKey
    },
    setError (state, error) {
      state.error = error
    },
    setLoading (state, loading) {
      state.loading = loading
    },
    resetData (state) {
      state.firstName = ''
      state.lastName = ''
      state.email = ''
      state.captcha = ''
      state.accountName = ''
      state.authority = ''
      state.publicKey = ''
      state.loading = false
      state.error = null
    }
  },
  actions: {
    async signup ({ commit, getters, dispatch, rootState, state }) {
      commit('setLoading', true)
      const data = getters.formData
      try {
        await Account.signup(data)
      } catch (error) {
        commit('setError', error)
        commit('setLoading', false)
        throw error
      }
      commit('setLoading', false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/signup-form.js